if($('.in-index').length){
    $('#content').append($('footer#footer .supportUs'));
}


